// 14-day bar chart for [{date, <field>}]. Bars carry a <title> so hovering shows the day and value.
export default function MiniBars({ days = [], field, muted = false, testId }) {
  const max = Math.max(1, ...days.map((d) => d[field] || 0));
  const total = days.reduce((n, d) => n + (d[field] || 0), 0);
  const w = 100 / Math.max(1, days.length);
  return (
    <div data-testid={testId}>
      <svg viewBox="0 0 100 40" preserveAspectRatio="none" className="h-16 w-full" role="img" aria-label={`${total} over ${days.length} days`}>
        {days.map((d, i) => {
          const h = ((d[field] || 0) / max) * 36;
          return (
            <rect key={d.date} x={i * w + w * 0.15} y={40 - Math.max(h, 1)} width={w * 0.7} height={Math.max(h, 1)} rx="0.8"
              fill={muted ? "var(--cw-border-strong)" : d[field] ? "var(--cw-brand)" : "var(--cw-surface-tertiary)"}>
              <title>{`${d.date}: ${d[field] || 0}`}</title>
            </rect>
          );
        })}
      </svg>
      <div className="cw-muted mt-1 flex justify-between text-[11px] tabular-nums"><span>{days[0]?.date?.slice(5)}</span><span>{days[days.length - 1]?.date?.slice(5)}</span></div>
    </div>
  );
}
